import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import ArrowForwardIcon from '@guildeducationinc/recess/icons/ArrowForwardIcon';
import IneligiblePictogram from '@guildeducationinc/recess/pictograms/IneligiblePictogram';
import { EmployeeContext } from '@src/contexts/EmployeeContextProvider';
import { useAuth } from '@src/hooks/useAuth';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import styles from './EligibilityNotice.module.scss';
export const EligibilityNotice = () => {
    const { t } = useLocale();
    const { currentUser } = useAuth();
    const { isEligible, eligibilityLoading } = useContext(EmployeeContext);
    if (eligibilityLoading || !currentUser || isEligible) {
        return null;
    }
    return (_jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.icon, children: _jsx(IneligiblePictogram, { size: 32 }) }), _jsxs("div", { className: styles.content, children: [_jsx(Typography, { variant: 'body2', children: t('You are NOT ELIGIBLE because you do not meet {employerName} eligibility requirement(s).', { values: { employerName: currentUser.clientInfo?.name } }) }), _jsxs(TrackableButton, { btnType: 'link', enText: 'Employer policy', tag: 'eligibility_notice', component: Link, className: styles.benefitsLink, to: '/reimbursement-policy', children: [t("View {employerName}'s requirements", {
                                values: { employerName: currentUser.clientInfo?.name },
                            }), _jsx(ArrowForwardIcon, { size: 16 })] })] })] }));
};
